import { el, setChildren, setAttr, mount, unmount } from '/lib/redom.es.js';

import {
  displayElementAroundAnchor
} from '/modules/utilities/element-position.js';

import CSSLoader from '/modules/css-loader/index.js';

CSSLoader.load('/components/core/tooltip/index.css');

const globalState = {
  delay: 200,
  tooltipsContainer: null,
  active: false,
  futureCallReferences: {
    display: null,
    hide: null
  }
};

class Tooltip {

  constructor(configuration) {

    this.content = this.buildTooltipContent(configuration.content);
    this.target = configuration.target;
    this.placement = configuration.placement || 'bottom';
    this.offset = configuration.offset || 0;

    this.target.addEventListener('mouseenter', this.handleMouseEnterEvent.bind(this));
    this.target.addEventListener('mouseleave', this.handleMouseLeaveEvent.bind(this));
    this.target.classList.add('tooltip-target');

    this.el = el('.tooltip-main', [this.content]);

  }

  destroy() {
    this.target.classList.remove('tooltip-target');
  }

  buildTooltipContent(content) {

    if (typeof content === 'string') {
      return el('label', content);
    }

    return content;

  }

  getTooltipsContainer() {

    if (globalState.tooltipsContainer === null) {
      globalState.tooltipsContainer = el('#tooltips-container');
      mount(document.body, globalState.tooltipsContainer);
    }

    return globalState.tooltipsContainer;

  }

  displayTooltip() {

    globalState.active = true;

    setChildren(this.getTooltipsContainer(), [this.el]);

    const element = this.el;
    const anchorElement = this.target;
    const viewportElement = document.body;
    const verticalOffset = 5;
    const horizontalOffset = 0;
    const startSide = 'bottom';
    const placeOnCenter = true;
    const positionableSides = ['bottom'];

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);
    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

    setAttr(element, { style: { height: 'auto' } });

  }

  hideTooltip() {

    globalState.active = false;

    unmount(this.getTooltipsContainer(), this.el);

  }

  handleMouseEnterEvent() {

    if (globalState.active === true) {
      clearInterval(globalState.futureCallReferences.hide);
      this.displayTooltip();
    } else {
      globalState.futureCallReferences.display = setTimeout(this.displayTooltip.bind(this), globalState.delay);
    }

  }

  handleMouseLeaveEvent() {

    globalState.futureCallReferences.hide = setTimeout(this.hideTooltip.bind(this), globalState.delay);

  }

  update(configuration) {

    this.content = this.buildTooltipContent(configuration.content);

    setChildren(this.el, [this.content]);

  }

}

export default Tooltip;